const comments = [
  {
    name: '漫画迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20portrait%20of%20a%20young%20Chinese%20man%20with%20short%20dark%20hair%20and%20warm%20smile%2C%20simple%20warm%20colored%20circular%20portrait%20illustration%2C%20anime%20inspired%20art%20style%20with%20soft%20shading%2C%20plain%20light%20cream%20background&width=100&height=100&seq=avatar-01&orientation=squarish',
    time: '2小时前',
    content: '古古漫画网的下拉式阅读体验真的太爽了！一口气看了三十话《斗破苍穹》，完全没有翻页打断，沉浸感超强。而且画质高清无广告，良心平台！',
  },
  {
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20portrait%20of%20a%20young%20Chinese%20woman%20with%20long%20dark%20hair%20and%20gentle%20smile%2C%20simple%20warm%20colored%20circular%20portrait%20illustration%2C%20anime%20inspired%20art%20style%20with%20soft%20shading%2C%20plain%20light%20cream%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    time: '5小时前',
    content: '终于找到一个日漫韩漫国漫都全的地方了！《我独自升级》和《鬼灭之刃》同时追完全不用换站，更新的速度也很快，基本实时同步连载进度。',
  },
  {
    name: '追漫达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20portrait%20of%20a%20young%20Chinese%20man%20with%20stylish%20hair%20and%20friendly%20expression%2C%20simple%20warm%20colored%20circular%20portrait%20illustration%2C%20anime%20inspired%20art%20style%20with%20soft%20shading%2C%20plain%20light%20cream%20background&width=100&height=100&seq=avatar-03&orientation=squarish',
    time: '1天前',
    content: '从大学开始就在这里追漫了，三年铁粉实名推荐！漫画大全分类很细，冷门小众作品也能找到。而且手机端优化做得特别棒，通勤路上追更无压力。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">读者心声</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            来看看漫画同好们怎么说，加入古古漫画网一起畅享阅读
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((cmt) => (
            <div
              key={cmt.name}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img src={cmt.avatar} alt={cmt.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">{cmt.name}</div>
                  <div className="text-xs text-foreground-400">{cmt.time}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-accent-500"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{cmt.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}